import { render, staticRenderFns } from "./HideChannels.vue?vue&type=template&id=2918770f"
import script from "./HideChannels.vue?vue&type=script&lang=js"
export * from "./HideChannels.vue?vue&type=script&lang=js"
import style0 from "./HideChannels.vue?vue&type=style&index=0&id=2918770f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports